<template>
  <BookBlock :list="borrowHistory" :type="2"  @onLoad="onLoad" ref="bookChild" flag='order'/>
</template>

<script>
import {defineComponent,onMounted, ref} from "vue";
import BookBlock from './BookBlock';
import {getLoanHists} from '@/api/users';
import {isNotEmpty, setCovers} from '@/utils/util';

export default defineComponent({
  name: 'BorrowHistory',
  components: {
    BookBlock,
  },
  setup(){
        const borrowHistory = ref([]);
        const bookChild = ref();
        const total = ref(0);
        let page = 1;
        const onLoans = ()=>{
            getLoanHists(page, 10)
                .then(data => {
                    if(data){
											const isbns =[];
                        total.value = data.total;
                        if(isNotEmpty(data.items)){
                            let arr = [];
                            data.items.forEach(item  => {
                                if(isNotEmpty(item.item) && isNotEmpty(item.item.bibAttrs)){
                                    let temp = item.item.bibAttrs;
                                    let loanDate = item.loanDate;
                                    let retDate = item.retDate;
                                    if(loanDate){
                                        loanDate = loanDate.substring(0,19);
                                    }
                                    if(retDate){
                                        retDate = retDate.substring(0,19);
                                    }
                                    Object.assign(temp, {loanDate: loanDate,retDate: retDate, price: item.item.price, bookId:item.book?.bookId ?? '',vendorName:item.book?.vendor?.vendorName ?? '',coverUrl:item.book.coverUrl ?? ''});
                                    arr.push(temp);
                                    if(isNotEmpty(item.item.bibAttrs.isbn)){
                                        isbns.push(item.item.bibAttrs.isbn);
                                    }
                                }else {
                                    arr.push({});
                                }
                            });
                            if(isNotEmpty(isbns)){
															setCovers(isbns,arr);
                            }
                            borrowHistory.value = borrowHistory.value.concat(arr);
                        }
                        page++;
                    }
                    if(isNotEmpty(bookChild.value)){
                        bookChild.value.loading = false; // 加载状态结束
                        bookChild.value.finished = borrowHistory.value.length >= total.value;
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        };
        const onLoad =() => {
            if(borrowHistory.value.length < total.value){
                onLoans();
            }else {
                bookChild.value.loading = false; // 加载状态结束
                bookChild.value.finished = borrowHistory.value.length >= total.value;
            }
        };
        onMounted(() => {
            onLoans();
        });
        return{
            onLoans,
            borrowHistory,
            onLoad,
            bookChild,
            total
        }
    },
});
</script>

<style scoped lang="less">

</style>
